import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserLogInAndSecurityService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CustomerUserLogInAndSecurity_CustomerUserLogInAndSecurityDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetUserLoginAndSecurity = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_CustomerUserLogInAndSecurity_CustomerUserLogInAndSecurityDto | undefined,
  unknown
> => {
  const userLoginAndSecurity = useQuery(['getUserLoginAndSecurity'], async () => {
    return await handleRequest(
      CustomerUserLogInAndSecurityService.getApiCustomerApiAppCustomerUserLogInAndSecurityCustomerUserLogInAndSecurity()
    );
  });
  return userLoginAndSecurity;
};

export default useGetUserLoginAndSecurity;
